import { GraphQLError } from "graphql";

interface SATerror {
    CodigoError: string; //"CFDI33132"
    ExtraInfo: string; //"" (Might have correct ZIP, Receptor Name or Else)
    FechaRegistro: string; //"2021-11-12T11:29:22"
    IdIncidencia: string; //"19de5732-cb92-44b8-966f-e8d61be516f4"
    MensajeIncidencia: string; // "Este RFC del receptor no existe en la lista de RFC inscritos no cancelados del SAT"
    NoCertificadoPac: string; //"00001000000504204441"
    RfcEmisor: string; //""
    Uuid: string; // ""
    WorkProcessId: string; //"7234b893-9c8b-4bb1-b856-118df5eb02b6"
}

interface StampingInputError {
    origin: 'SAT' | 'PRE_VALIDATION',
    codigoError: string,        // Can be SAT Incidencia err, or Pre Validation error code
    mensajeIncidencia: string,  // Message for user
    badRequests: any | null,    // Only available when origin is PRE_VALIDATION
}

const satExplainGeneralErrors = (codigoError: string, originalMensajeIncidencia: string) => {
    // No extra info
    if (codigoError === 'CFDI40138') {
        // Emisor Name Error
        return `El nombre del emisor debe ser igual al registrado en el CSD`
    }
    if (codigoError === 'CFDI40147') {
        // Receptor Zip Error
        return `Código Postal del Receptor no es el registrado en el SAT`
    }
    if (codigoError === 'CFDI40144') {
        // Receptor Name Error
        return `Nombre del Receptor no es el registrado en el SAT`
    }
    if (codigoError === 'CFDI40143') {
        // Receptor RFC Error
        return `El RFC del receptor es incorrecto o no existe`
    }
    return originalMensajeIncidencia;
}

export const parseStampErrorFromGraphQL = (error: GraphQLError) => {
    if (!error) return 'Error desconocido, comuníquelo a soporte para resolverlo a la brevedad';
    if (!error.extensions) return error.message;
    if (!error.extensions.origin) return error.message;
    if (!(error.extensions.origin === 'SAT' || error.extensions.origin === 'PRE_VALIDATION')) return error.message;

    // Assume error is StampingInputError type on extensions
    const stampingError: StampingInputError = {
        origin: error.extensions.origin,
        codigoError: error.extensions.codigoError,
        mensajeIncidencia: error.extensions.mensajeIncidencia,
        badRequests: error.extensions.badRequests ?? null
    }

    if (stampingError.origin === 'PRE_VALIDATION') {
        return `[${stampingError.codigoError}] ${stampingError.mensajeIncidencia}`;
    }

    return `[${stampingError.codigoError}] ${satExplainGeneralErrors(stampingError.codigoError, stampingError.mensajeIncidencia)}`
}